import api from "../axiosIntercepture";

const BASE = "courier";

export const getCourierList = async () => {
  try {
    const response = await api.get(`${BASE}/getCourierList`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? [];
  } catch (err) {
    console.error("Error fetching courier list:", err);
    throw err?.response?.data?.message || "Failed to fetch courier list";
  }
};

export const createCourier = async (payload) => {
  try {
    const response = await api.post(`${BASE}/create`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error creating courier:", err);
    throw err?.response?.data?.message || "Failed to create courier";
  }
};

export const updateCourier = async (id, payload) => {
  try {
    const response = await api.put(`${BASE}/update/${id}`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error updating courier:", err);
    throw err?.response?.data?.message || "Failed to update courier";
  }
};

export const deleteCourier = async (id) => {
  try {
    const response = await api.delete(`${BASE}/delete/${id}`);
    if (response.data?.success) {
      return response.data.data;
    }
    return response.data;
  } catch (err) {
    console.error("Error deleting courier:", err);
    throw err?.response?.data?.message || "Failed to delete courier";
  }
};
